import { Injectable } from '@angular/core';
import { BaseEvaluationService } from '@luzula/luzula-lib';
import { karbonatEval } from './evaluators/karbonat';
import { maechtigkeitEval } from './evaluators/maechtigkeit';
import { phDurchschnittEval } from './evaluators/ph';
import { nWSKEval, nWSKStufeEval, schichtNWSKEval } from './evaluators/nwsk';
import { substratfeuchteEval } from './evaluators/substratfeuchte';
import { entwaesserungsverhaltenEval } from './evaluators/entwaesserung';
import { identityEval } from './evaluators/identity';
import { schichtAnteilEval } from './evaluators/schichtanteil';

// Re-export für Kompatibilität
export type EvalFunc = (context: unknown, i?: number, key?: string, override?: number, flag?: boolean) => string | number | undefined;

@Injectable({
	providedIn: 'root'
})
export class EvaluationService extends BaseEvaluationService {
	constructor() {
		super();
		// Bohrpunkte-spezifische Evaluatoren registrieren
		this.registerEvaluator("SMächtigkeit", maechtigkeitEval);
		this.registerEvaluator("SnWSK", schichtNWSKEval);
		this.registerEvaluator("nWSK", nWSKEval);
		this.registerEvaluator("nWSKStufe", nWSKStufeEval);
		this.registerEvaluator("Substratfeuchte", substratfeuchteEval);
		this.registerEvaluator("Entwässerungsvorschlag", entwaesserungsverhaltenEval);
		this.registerEvaluator("HMächtigkeit", maechtigkeitEval);
		this.registerEvaluator("Karbonattiefe", karbonatEval);
		this.registerEvaluator("pH-Durchschnitt", phDurchschnittEval);
		// Soll man die ermittelten Werte hier noch ändern können? Dann Evaluatoren entfernen.
		this.registerEvaluator("KlimastufeNeu", identityEval);
		this.registerEvaluator("Koordinatensystem", identityEval);
		this.registerEvaluator("Schichtanteilb1", schichtAnteilEval('b1'));
		this.registerEvaluator("Schichtanteilb2", schichtAnteilEval('b2'));
		this.registerEvaluator("Schichtanteilstr", schichtAnteilEval('str'));
		this.registerEvaluator("Schichtanteilkr1", schichtAnteilEval('kr1'));
		this.registerEvaluator("Schichtanteilkr2", schichtAnteilEval('kr2'));
		this.registerEvaluator("Schichtanteilm", schichtAnteilEval('m'));
	}
}
